<template>
  <div>
    <el-dialog
      id="openMethodSel"
      class="KNS-dialog"
      :visible.sync="openMethodSel"
      width="900px"
      center
    >
      <span
        slot="title"
        class="dialog-title"
      >
        <div class="title-bar">
          <span class="title">快速開通服務</span>
          <span class="subtitle">{{ $t('BindingHousehold.SelectBindingMethod', {tabletNote: tabletInfo.TabletNote}) }}</span>
        </div>
        <div
          class="advanced-cog"
          @click="$router.push({ name: 'householdDashboard' })"
        >
          <i
            class="icon-cog"
            aria-hidden="true"
          />
          進階功能 (開通狀況、解除綁定)
        </div>
      </span>
      <div class="way-select">
        <h5>請選擇您的開通方式</h5>
        <ul>
          <li @click="barcodeOpen">
            <img
              src="../assets/img/Barcode/barcode.png"
              alt="新增裝置"
            >
            <h3>手機條碼</h3>
          </li>
          <li @click="nfcOpen">
            <img
              src="../assets/img/NFC/nfc.png"
              alt="新增載具"
            >
            <h3>門禁卡、磁扣</h3>
          </li>
          <li @click="snOpen">
            <img
              src="../assets/img/SN/sn.png"
              alt="新增裝置"
            >
            <h3>手機序號</h3>
          </li>
        </ul>
      </div>
    </el-dialog>
    <reader ref="reader" />
    <hosuehold-frame
      :open.sync="householdSwitch"
      type="KNS-HK"
      :title="titleObj"
      @select-household="selectedHousehold"
    />

    <GetActivationCode
      ref="getActivationCode"
    />
  </div>
</template>

<script>
import householdFrame from '@/components/HouseholdFrame'
import ReadNFCBarcode from '@/components/ReadNFCBarcode'
import GetActivationCode from '@/components/GetActivationCode'
import { housekeeperAPI } from '@/api/HousekeeperAPI.js'

export default {
  components: {
    'hosuehold-frame': householdFrame,
    reader: ReadNFCBarcode,
    GetActivationCode
  },
  data () {
    return {
      openMethodSel: false,
      householdSwitch: false,
      tabletInfo: Object,
      titleObj: {
        title: '快速開通服務',
        SubTitle: '請選擇住戶資訊(棟別、樓層、戶別)',
        introduction: 'https://www.smartdaily.com.tw/guide-to-use-certified-the-residents/',
        btn: {
          icon: 'icon-cog',
          text: '進階功能 (開通狀況、解除綁定)',
          btnevent: () => {
            this.$router.push({ name: 'householdDashboard' })
          }
        }
      }
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    faseActive () {
      this.householdSwitch = true
    },
    selectedHousehold (val) {
      this.tabletInfo = val
      this.householdSwitch = false
      this.openMethodSel = true
    },
    nfcOpen () {
      const vobj = this
      this.$refs.reader.getCode((code) => {
        sandAPI(code)
        function sandAPI (code) {
          const codeList = []
          let nowInd = 0
          if (typeof (code) === 'string') { codeList.push(code) } else { code.map(val => codeList.push(val)) }
          API()
          function API () {
            housekeeperAPI.bindResidentCarrierCode(vobj.tabletInfo.TabletId, codeList[nowInd]).then(res => {
              let msgObj = Object
              // eslint-disable-next-line eqeqeq
              if (res.data.status == 'fail' || res.data.status == 'error') {
                msgObj = { title: '新增失敗!!', message: this.$t('General.PleaseContactUs'), type: 'error' }
              } else {
                // eslint-disable-next-line eqeqeq
                if (res.data.status == 'repeat') {
                  msgObj = { title: '載具已歸戶!!', message: '', type: 'success' }
                // eslint-disable-next-line eqeqeq
                } else if (res.data.status == 'restart') {
                  msgObj = { title: '載具已重新啟用!!', message: '住戶可憑此載具進行包裹領取', type: 'success' }
                } else {
                  msgObj = { title: '載具新增成功!!', message: '住戶可憑此載具進行包裹領取', type: 'success' }
                }
              }
              if (codeList.length > 1) { msgObj.title = `(${nowInd + 1}/${codeList.length})` + msgObj.title }
              vobj.$notify(msgObj)
              nowInd++
              if (nowInd <= codeList.length - 1) {
                API()
              } else {
                vobj.$refs.reader.close()
              }
            }).catch(err => {
              vobj.$notify.error({ title: '發生未知錯誤!!', message: this.$t('General.PleaseContactUs') })
              if (nowInd <= codeList.length - 1) {
                API()
              } else {
                vobj.$refs.reader.close()
              }
            })
          }
        }
      }, {
        type: 'NFC',
        model: 'active',
        tabletInfo: this.tabletInfo
      })
    },
    barcodeOpen () {
      const vobj = this
      this.$refs.reader.getCode((code) => {
        sandAPI(code)
        function sandAPI (code) {
          const codeList = []
          let nowInd = 0
          if (typeof (code) === 'string') { codeList.push(code) } else { code.map(val => codeList.push(val)) }
          API()
          function API () {
            housekeeperAPI.bindResidentDeviceSn(vobj.tabletInfo.TabletId, codeList[nowInd]).then(res => {
              let msgObj = Object
              // eslint-disable-next-line eqeqeq
              if (res.data.Data.Status == 'success' || res.data.Data.Status == 'update_success') {
                msgObj = { title: '裝置開通成功!!', message: '住戶可憑此手機條碼進行包裹領取', type: 'success' }
              } else {
                // eslint-disable-next-line eqeqeq
                if (res.data.Data.Status == 'com_tablet_device_repeat') {
                  msgObj = { title: '裝置已開通!!', message: '', type: 'success' }
                } else {
                  msgObj = { title: '開通失敗!!', message: this.$t('General.PleaseContactUs'), type: 'error' }
                }
              }
              if (codeList.length > 1) { msgObj.title = `(${nowInd + 1}/${codeList.length})` + msgObj.title }
              vobj.$notify(msgObj)
              nowInd++
              if (nowInd <= codeList.length - 1) {
                API()
              } else {
                vobj.$refs.reader.close()
              }
            }).catch(err => {
              vobj.$notify.error({ title: '發生未知錯誤!!', message: this.$t('General.PleaseContactUs') })
              if (nowInd <= codeList.length - 1) {
                API()
              } else {
                vobj.$refs.reader.close()
              }
            })
          }
        }
      }, {
        type: 'Barcode',
        model: 'active',
        tabletInfo: this.tabletInfo
      })
    },
    snOpen () {
      this.$refs.getActivationCode.open(this.tabletInfo.TabletId, this.tabletInfo.TabletNote)
    }

  }
}
</script>

<style lang="sass" scoped>
  .KNS-dialog
    ::v-deep .el-dialog
      +KNSDialog
      .el-dialog__body
        padding: 20px 15px 20px 15px
  .way-select
    h5
      font-size: 28px
      text-align: center
      color: #f45f53
      margin: 10px 0px
      font-weight: 500
    img
      width: 160px
      height: 160px
      object-fit: contain
      margin-top: 20px
    ul
      padding: 0 !important

</style>
